module.exports = {
    ENV: process.env.REACT_APP_PUBLIC_ENVIRONMENT,
    BaseURL: process.env.REACT_APP_API_BASE_URL,
};
